<template>
  <div>
    <div v-if="!loading">
      <!-- Widget -->
      <ContentComponent
        v-if="episode"
        :channel-url="channelUrl"
        :episode-image-url="episode ? episode.image_url : null"
        :podcast-image-url="episode.podcast_image_url"
        :podcast-name="episode.podcast_name"
        :embed-path="`episodes/${episodeId}`"
        :direct-link="episodeEmbedUrl"
        :audio-url="audioUrl"
        :episode="episode"
        :peaks-data="episode.episode_peaks_data"
      />
      <div v-else class="placeholder-rectangle text-font text-opacity-70 heading-s-700">
        Episode not found!
      </div>
    </div>
    <div v-else class="placeholder-rectangle">
      <Spinner radius="60" thickness="2" />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import ContentComponent from '@/components/shared/ContentComponent';

export default {
  name: 'EmbedEpisode',
  components: { ContentComponent },

  data() {
    return {
      loading: true,
      episodeId: this.$route.params.episodeId,
      episodeEmbedUrl: '',
      channelUrl: null,
      currentSpeed: { id: 1, label: '1x' },
      speedOptions: [
        { id: 0.5, label: '0.5x' },
        { id: 0.75, label: '0.75x' },
        { id: 1, label: '1x' },
        { id: 1.25, label: '1.25x' },
        { id: 1.5, label: '1.5x' },
        { id: 1.75, label: '1.75x' },
        { id: 2, label: '2x' },
      ],
    };
  },

  computed: {
    ...mapGetters({
      episode: 'activeEpisode',
    }),

    audioUrl() {
      return this.episode ? this.episode.audio_with_ads_url : null;
    },
  },

  mounted() {
    this.initialize();
  },

  methods: {
    ...mapActions({
      fetch: 'getEmbedEpisode',
    }),

    async initialize() {
      try {
        await this.fetch(this.episodeId);

        this.episodeEmbedUrl = `${window.location.origin}/embed/episodes/${this.episodeId}`;
        this.channelUrl = `${process.env.VUE_APP_STUDEO_APP_ORIGIN}/channels/${this.episode.podcast_code}`;
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    setSpeed(value) {
      this.$refs.player.$refs.audioPlayer.AP.playbackRate = value;
      this.currentSpeed = this.speedOptions.find(speed => speed.id == value);
    },
  },
};
</script>

<style scoped lang="scss">
.placeholder-rectangle {
  @apply flex items-center justify-center h-60 bg-secondary rounded-xl;
}
</style>
